module.exports = __webpack_public_path__ + "assets/img/recruitBg.f2f09dd5.png";